<template>
    <v-row no-gutters>
        <v-col cols="12">
            <v-sheet class="card-rounded">
                <v-row no-gutters>
                    <!-- ระดับชั้นที่ต้องการสมัคร -->
                    <v-col cols="12" class="pa-4">
                        <v-row no-gutters justify="space-between">
                            <span class="header-text">{{ $t('message.adminPage.parentInfo.parentHeader') }}</span>
                            <v-btn
                                color="primary"
                                small
                                outlined
                                @click="onAction()"
                                class="square-btn"
                            >
                                <v-icon small>
                                    {{
                                        currentStep == 5
                                            ? "mdi-eye"
                                            : "mdi-pencil"
                                    }}</v-icon
                                >
                            </v-btn>
                        </v-row>
                        <v-row>
                            <v-col
                                cols="6"
                                v-for="(info, i) in parentInfo"
                                :key="i"
                                class="mb-2"
                            >
                                <v-sheet
                                    class="card-info-rounded"
                                    elevation="0"
                                    :color="info?.bg"
                                    :style="`border: 1px solid ${ info?.border }`"
                                >
                                    <v-row class="pa-2 py-4" no-gutters>
                                        <v-col cols="12" class="mb-3">
                                            <span
                                                v-text="$t(info?.title)"
                                                class="caption-text-secondary"
                                            ></span>
                                        </v-col>
                                        <v-col cols="12" class="mb-2">
                                            <v-icon left :color="info?.color"
                                                >mdi-account</v-icon
                                            >
                                            <span
                                                class="default-text"
                                            >
                                            {{ fullName(info?.fullName) }}
                                            </span>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-icon left :color="info?.color"
                                                >mdi-phone</v-icon
                                            >
                                            <span
                                                class="default-text"
                                                v-text="info?.phoneNumber"
                                            >
                                            </span>
                                        </v-col>
                                    </v-row>
                                </v-sheet>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-sheet>
        </v-col>
    </v-row>
</template>

<script>
import i18n from '@/i18n';
export default {
    props: {
        applicantInfo: Object,
        parentInformation: Array,
        currentStep: String,
    },
    mounted() {
        this.retrievedData();
    },
    data() {
        return {
            parentInfo: [],
        };
    },
    computed:{
        locale(){
            return i18n.locale;
        }  
    },
    methods: {
        retrievedData() {
            let parentInfo = JSON.parse(JSON.stringify(this.parentInformation));
            this.parentInfo = parentInfo;
        },
        onAction() {
            let action = this.currentStep == 5 ? "view" : "edit";
            this.$emit(`onAction`, action, `parents`);
        },
        fullName(parent) {
            // return `${parent?.prefix?.[`text_${this.locale}`]} ${parent?.[`name_${this.locale}`]} ${parent?.[`surname_${this.locale}`]}`
            return `${parent?.[`prefix_${this.locale}`]} ${parent?.[`name_${this.locale}`]} ${parent?.[`surname_${this.locale}`]}`
        },
    },
};
</script>

<style scoped lang="scss">
.square-btn {
    min-width: 36px !important;
    width: 36px !important;
    height: 36px !important;
}
.header-text {
    font-family: "Prompt";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 23px;
    color: #255d98;
}
.caption-text-secondary {
    font-family: "Prompt";
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #37323c;
}
.caption-text {
    font-family: "Prompt";
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #9d9b9a;
}
.default-text {
    font-family: "Sarabun";
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #37323c;
}

[class*="-text"] {
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}
.card-rounded {
    background: #ffffff;
    box-shadow: 0px 0px 20px rgba(232, 232, 232, 0.7) !important;
    border-radius: 10px 10px 10px 10px;
}
.card-info-rounded {
    border-radius: 10px;
}
</style>
